export const eventStrings = {
  ccw: 'CCW 2023',
  ccw2024: 'CCW 2024',
  internorga: 'Internorga 2023',
  omr: 'OMR 2023',
  sesu: 'Service Summit 2023',
}